import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { withSubscriptions } from 'Components/WithSubscriptions';
import { useSelectPlans } from 'Hooks/useSelectPlan';
import { CenterFrameLayout } from 'Layouts';
import { SheerIdBanner } from 'Features/SheerIdPromoBanner/SheerIdBanner';
import { PlanSelection } from 'Features/Plans/PlanSelection/PlanSelection';
import { isFirstResponderChurned, isMilitaryChurned } from 'Utils/SheerIdHelpers';
import './SignUpPlansContainer.css';

const SignUpPlansComponent = () => {
  const selectablePlans = useSelectPlans({ isPlansCopyV3: true });

  const { selectedPlan } = useSelector((s) => s.plans);
  const { enableSheerIdBanner } = useSelector((s) => s.appConfig.defaultConfig);
  const subscription = useSelector((s) => s.subscription);

  const isSheerIdChurned =
    isFirstResponderChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails) ||
    isMilitaryChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails);

  const showSheerIdBanner = useMemo(
    () => enableSheerIdBanner && !!selectablePlans.length && !isSheerIdChurned,
    [enableSheerIdBanner, selectablePlans, isSheerIdChurned]
  );

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_PLAN_SELECT_START);
  }, []);

  return (
    <CenterFrameLayout
      title="Choose a Plan"
      showLoader={!selectablePlans.length}
      modernLayout
      customClass="signUpPlansContainer"
    >
      {showSheerIdBanner && <SheerIdBanner />}
      <PlanSelection plans={selectablePlans} selectedPlan={selectedPlan} />
    </CenterFrameLayout>
  );
};
export const SignUpPlansContainer = withSubscriptions(SignUpPlansComponent);
